import { PackageGeneralFormView } from '../view/PackageGeneralFormView';
import { templatePackageGeneralForm } from '../view/template';
import { BaseWebComponentController, WebComponentEvent } from '../../../../framework/BaseWebComponentController';
import { PackageGeneralFormWebComponent } from '../component/PackageGeneralFormWebComponent';
import { PackageGeneralFormRepository } from '../repository/PackageGeneralFormRepository';
import { PackageGeneralFormViewData } from '../types/PackageGeneralFormViewData';
import { LanguageData } from '../../../types/language-data';

export class PackageGeneralFormController extends BaseWebComponentController {
  public component: PackageGeneralFormWebComponent;
  public view: PackageGeneralFormView;
  public viewConstructor: typeof PackageGeneralFormView;

  public dataRepository: PackageGeneralFormRepository;
  public dataRepositoryConstructor: typeof PackageGeneralFormRepository;
  private currentCompany: string;

  constructor(component: PackageGeneralFormWebComponent) {
    super(component);

    this.initialSetup({
      viewConstructor: PackageGeneralFormView,
      viewTemplate: templatePackageGeneralForm,
      dataRepositoryConstructor: PackageGeneralFormRepository,
    });
  }

  computeEventListeners() {
    return [
      {
        element: this.view.dom.$companyFormField.Input,
        event: 'selectionChange',
        callback: this.onCompanyChanged,
      },
    ];
  }

  public onCompanyChanged(event: WebComponentEvent): void {
    if (!event.detail.selectedValue) {
      return;
    }
    //ensure that the event is not triggered twice
    if (!this.currentCompany || this.currentCompany !== event.detail.selectedValue) {
      this.currentCompany = event.detail.selectedValue;
      this.view.onCompanyChanged(event.detail.selectedValue);
    }
  }

  public async getDataForView(): Promise<PackageGeneralFormViewData> {
    const languages: LanguageData[] = this.dataRepository.getLanguages();

    return {
      languages: languages,
      packageType: this.component.getPackageType(),
      company: this.component.getCompany(),
      packageId: this.component.packageId,
      context: this.component.formContext,
      panelType: this.component.panelType,
    };
  }
}
